module.exports = __webpack_public_path__ + "img/MatchTheRunes.28de95a0.png";